import { Clock, Users } from "lucide-react";
import { AgeBadge, ThemeBadge } from "@/components/yarn/Badges";

export function GameCard({ game, onJoin, index }) {
  const full = game.players >= game.max_players;
  const waiting = game.phase === "waiting";
  return (
    <div className="patch p-5 rise-in flex flex-col gap-4" style={{ animationDelay: `${index * 60}ms` }} data-testid={`game-card-${game.code}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="font-display text-xl font-semibold truncate" data-testid={`game-card-name-${game.code}`}>{game.name}</h3>
          <p className="text-sm text-[var(--yarn-muted)] truncate">hosted by {game.host_name}</p>
        </div>
        <AgeBadge rating={game.age_rating} testid={`game-card-age-${game.code}`} />
      </div>
      <div className="flex flex-wrap items-center gap-2 text-sm text-[var(--yarn-muted)]">
        <ThemeBadge theme={game.theme} />
        <span className="inline-flex items-center gap-1"><Users size={15} /> {game.players}/{game.max_players}</span>
        <span className="inline-flex items-center gap-1"><Clock size={15} /> {game.round_seconds}s lines</span>
      </div>
      <div className="flex items-center justify-between gap-3">
        <span className="text-xs font-display uppercase tracking-wider" style={{ color: waiting ? "var(--yarn-sage)" : "var(--yarn-mustard)" }}>
          {waiting ? "Waiting for players" : game.phase === "ended" ? "Between stories" : "Story in progress"}
        </span>
        <button className="btn-yarn h-11 px-6" disabled={full} onClick={() => onJoin(game.code)} data-testid={`join-game-button-${game.code}`}>
          {full ? "Full" : "Join"}
        </button>
      </div>
    </div>
  );
}
